import {ObjUtil} from 'yougile-util'
import {
  CompanyPreferences,
  companyPreferencesFallback,
  CompanyPreferencesUserKind,
  DataObjectId,
  Hub
} from 'yougile-model'
import {globals} from '@extensions/globals-base'
import {DepartmentsClient} from './departments-client'
import {PermissionsChecker} from './permissions-checker'
import {Sync} from './sync'

export class CompanyPreferencesClient {
  public static get(companyId: DataObjectId): CompanyPreferences {
    const box = Sync.get({companyId})
    const companyHub = box.get(box.companyId) as Hub
    const pref =
      companyHub.data.companyPreferences || companyPreferencesFallback
    ObjUtil.forEach(companyPreferencesFallback, k => {
      if (typeof pref[k] === 'undefined') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore // key value types are of various incompatible types
        pref[k] = companyPreferencesFallback[k] as any
      }
    })
    return pref
  }

  public static set(
    companyId: DataObjectId,
    newPref: CompanyPreferences
  ): void {
    const box = Sync.get({companyId})
    const companyHub = box.get(box.companyId) as Hub
    companyHub.data.companyPreferences = newPref
    companyHub.commit()
  }

  public static getUserKind(params: {
    companyId: DataObjectId
    userId: DataObjectId
  }): CompanyPreferencesUserKind {
    const {userId, companyId} = params
    const box = Sync.get({companyId})
    const isAdmin = PermissionsChecker.isAdmin({userId, box})
    if (isAdmin) {
      return 'admins'
    } else {
      if (DepartmentsClient.isManager(box, userId)) {
        return 'managers'
      } else {
        return 'all'
      }
    }
  }

  public static isAllowedForCurrentUser(
    companyId: DataObjectId,
    action: keyof CompanyPreferences
  ): boolean {
    if (action === 'editPosition') {
      throw new TypeError('Can’t process this action by this method')
    }
    const whoCan = CompanyPreferencesClient.get(companyId)[action]
    const userId = globals.currentUserId
    const userKind = CompanyPreferencesClient.getUserKind({
      companyId,
      userId
    })
    return userKind === 'admins' || whoCan === 'all' || whoCan === userKind
  }
}
